import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`posthog.capture('user signed up');
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`posthog.capture('user signed up', {
    login_type: "email",
    is_free_trial: true
})
`}</code></pre>
    <h3 {...{
      "id": "page-views-and-autocapture"
    }}>{`Page views and autocapture`}</h3>
    <p>{`By default, PostHog automatically captures the following frontend events:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Pageviews`}</strong>{`, including the URL.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/product-analytics/autocapture"
        }}><strong parentName="a">{`Autocaptured events`}</strong></a>{`, such as any `}<inlineCode parentName="li">{`click`}</inlineCode>{`, `}<inlineCode parentName="li">{`change of input`}</inlineCode>{`, or submission associated with `}<inlineCode parentName="li">{`a`}</inlineCode>{`, `}<inlineCode parentName="li">{`button`}</inlineCode>{`, `}<inlineCode parentName="li">{`form`}</inlineCode>{`, `}<inlineCode parentName="li">{`input`}</inlineCode>{`, `}<inlineCode parentName="li">{`select`}</inlineCode>{`, `}<inlineCode parentName="li">{`textarea`}</inlineCode>{`, and `}<inlineCode parentName="li">{`label`}</inlineCode>{` tags.`}</li>
    </ul>
    <p>{`If you prefer to disable these, set the appropriate values in your `}<a parentName="p" {...{
        "href": "/docs/libraries/js#config"
      }}>{`configuration options`}</a>{`.`}</p>
    <h3 {...{
      "id": "single-page-apps-and-pageviews"
    }}>{`Single-page apps and pageviews`}</h3>
    <p>{`PostHog automatically sends `}<inlineCode parentName="p">{`pageview`}</inlineCode>{` events whenever it gets loaded. If you have a single-page app, that means it only sends a pageview once (when your app loads).`}</p>
    <p>{`To make sure any navigating a user does within your app gets captured, you can make a pageview call manually.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`posthog.capture('$pageview')
`}</code></pre>
    <p>{`This automatically sends the current URL along with other relevant properties.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      